import { promptToPlainText } from "@seedance/contracts";
import { CanvasPromptEditor } from "../nodes/InlineTextEditor.js";
import type { CanvasDocumentV3 as CanvasDocument } from "@seedance/contracts";
import { canvasCopy } from "../../copy/zh-CN.js";

export interface MobileNodeListProps {
  document: CanvasDocument;
  selectedId?: string;
  onSelect(nodeId: string): void;
  onChange(document: CanvasDocument): void;
  onUndo?(): void;
  onRedo?(): void;
}

export function MobileNodeList(props: MobileNodeListProps) {
  const selected = props.document.nodes.find((node) => node.id === props.selectedId);
  return (
    <aside className="mobile-node-list" aria-label={canvasCopy.mobileNodeList}>
      <header><strong>{canvasCopy.nodes}</strong><span>{props.document.nodes.length}</span></header>
      <div className="mobile-node-list__items">
        {props.document.nodes.map((node) => (
          <button key={node.id} type="button" aria-pressed={node.id === selected?.id} onClick={() => props.onSelect(node.id)}>
            <strong>{node.kind === "text" ? promptToPlainText(node.text) || canvasCopy.emptyNote : node.kind === "script" ? promptToPlainText(node.title) || canvasCopy.manualScript : node.kind === "seedance" ? canvasCopy.seedanceNode : node.kind === "image" ? canvasCopy.imageNode : node.kind === "video" ? canvasCopy.videoNode : canvasCopy.audioNode}</strong>
            <small>{node.kind === "text" ? canvasCopy.textNode : node.kind === "script" ? canvasCopy.manualScript : node.kind === "seedance" ? canvasCopy.seedanceNode : node.kind === "image" ? canvasCopy.imageNode : node.kind === "video" ? canvasCopy.videoNode : canvasCopy.audioNode}</small>
          </button>
        ))}
      </div>
      {selected?.kind === "text" ? <label>{canvasCopy.addText}<CanvasPromptEditor document={props.document} source={{nodeId:selected.id,field:"text",inputEdgeId:null}} onChange={props.onChange} ariaLabel={canvasCopy.addText} maxLength={50_000} {...(props.onUndo ? {onUndo:props.onUndo} : {})} {...(props.onRedo ? {onRedo:props.onRedo} : {})} /></label> : null}
    </aside>
  );
}
